import {
  ElementCategoryID,
  type IElementCategory,
} from '../../../models/element-categories.model';
import { moveLifecycleAResults } from '../../../helpers/conversion-factors.helpers';
import { Lifecycle } from '../../../models/lifecycles.model';
import { coolingProperties } from './cooling-properties';
import {
  coolingProducts,
  COOLING_DEMAND_PER_INSTANCE_VARIABLE,
} from './cooling.model';
import { ENERGY_VARIABLE_NAME } from '@shared/helpers/energy/energy-expression-variables.models';
import { EXPRESSION_VARIABLE_NAME } from '@shared/constants/expression-variables-names.constant';
import { ExpressionVariables } from '@shared/helpers/expression-variables.helpers';

const getCoolingDemandPerInstance = (
  variables: ExpressionVariables,
): number => {
  const total = variables[ENERGY_VARIABLE_NAME.COOLING_DEMAND_SPACE] ?? 0;

  // When not active in proposal the count is 0 for this element.
  // Allow the calculation to happen anyway by setting to 1 (since this element always exist)
  const count =
    variables[EXPRESSION_VARIABLE_NAME.ACTIVE_ELEMENTS_COUNT_BY_CATEGORY]?.[
      ElementCategoryID.Cooling
    ] || 1;

  return total / count;
};

const mapExpressionVariablesBefore: IElementCategory['mapExpressionVariablesBefore'] =
  (variables) => ({
    ...variables,
    [COOLING_DEMAND_PER_INSTANCE_VARIABLE]:
      getCoolingDemandPerInstance(variables),
  });

/**
 * Map results from A1-A5 to B6 (Operational) on energy products (not on the production units)
 * @param results
 * @param param1
 * @returns
 */
const mapResults: IElementCategory['mapResults'] = (
  results,
  { productElement },
) =>
  productElement.unit === 'kWh'
    ? moveLifecycleAResults(results, Lifecycle.B6)
    : results;

// Element category quantity properties
const energyFactoryProperties: ReturnType<
  NonNullable<IElementCategory['getQuantityProperties']>
> = {
  energy: {
    displayUnit: 'kWh/yr',
    displayName: 'Annual cooling demand',
    fallbackCount: `${COOLING_DEMAND_PER_INSTANCE_VARIABLE}`,
  },
};

export const cooling: IElementCategory = {
  id: ElementCategoryID.Cooling,
  name: 'Cooling',
  properties: coolingProperties,
  disableQuantitySelection: true,
  mapResults,
  mapExpressionVariablesBefore,
  getQuantityProperties: () => energyFactoryProperties,
  getChildElements: () => coolingProducts,
  getElementPropertySelectionByProductId: () => undefined,
};
